'use client';
import {
    createContext,
    useCallback,
    useContext,
    useMemo,
    useState,
} from 'react';

const SidebarContext = createContext(null);

export function SidebarProvider({ children }) {
    const [active, setActive] = useState(null); // 'submit' | null
    const [isClosing, setIsClosing] = useState(false);

    const open = useCallback((name) => {
        setActive(name);
        setIsClosing(false);
    }, []);

    const close = useCallback(() => setActive(null), []);

    const startClosing = useCallback(() => setIsClosing(true), []);

    const value = useMemo(
        () => ({
            active,
            open,
            close,
            startClosing,
            isClosing,
            isOpen: (name) => active === name,
        }),
        [active, open, close, startClosing, isClosing],
    );

    return (
        <SidebarContext.Provider value={value}>
            {children}
        </SidebarContext.Provider>
    );
}

export function useSidebar() {
    return useContext(SidebarContext);
}
